'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('../getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _devLogger = require('../devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function copyMethods(wrappedInstance, decoratorInstance) {
  // Copy all methods from the wrapped component instance to this wrapper,
  // so that this wrapper is usable as a ref.
  if (!wrappedInstance) {
    return;
  }
  Object.getOwnPropertyNames(wrappedInstance).forEach(function (key) {
    if (typeof wrappedInstance[key] === 'function' && !decoratorInstance[key]) {
      decoratorInstance[key] = wrappedInstance[key];
    }
  });
}

function getCoreComponent(Component) {
  var node = Component;
  while (node.WrappedComponent) {
    node = node.WrappedComponent;
  }

  return node;
}

exports.default = function () {
  var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var url = arguments[1];

  return function (Component) {
    var name = (0, _getComponentName2.default)(Component);
    var message = '`' + name + '` is deprecated and will be removed in a future version. ' + reason;

    var DeprecatedComponent = _react2.default.createClass({
      displayName: 'DeprecatedComponent',

      statics: {
        isDeprecated: true,
        deprecated: {
          reason: reason,
          url: url
        }
      },

      componentWillMount: function componentWillMount() {
        _devLogger2.default.warn({ message: message, key: name, url: url });
      },
      render: function render() {
        var _this = this;

        return _react2.default.createElement(Component, _extends({}, this.props, { ref: function ref(_ref) {
            return copyMethods(_ref, _this);
          } }));
      }
    });

    DeprecatedComponent.displayName = 'Deprecated(' + name + ')';
    DeprecatedComponent.propTypes = Component.propTypes;
    DeprecatedComponent.defaultProps = Component.defaultProps;
    DeprecatedComponent.WrappedComponent = Component;
    DeprecatedComponent.CoreComponent = getCoreComponent(Component);

    return DeprecatedComponent;
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.47/js/decorators/deprecated.js
// module id = 377
// module chunks = 0